/**
 * Remove Cart Item Action
 * Triggered by: arc:action:removeCartItem
 */

export const runRemoveCartItem = async (data = {}) => {
    try {
        const { variantKey } = data;
        
        if (!variantKey) {
            throw new Error('Variant key is required');
        }

        // Trigger haptic feedback for removal
        if ('vibrate' in navigator) {
            navigator.vibrate([100, 50, 100]);
        }

        // Dispatch loading start event
        window.dispatchEvent(new CustomEvent('cart:remove_loading_start', { detail: { variantKey } }));

        // Use Alpine cart store
        await Alpine.store('cart').remove(variantKey);

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:item_removed', { detail: { variantKey } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { variantKey, quantity: 0 } }));
        window.dispatchEvent(new CustomEvent('cart:remove_loading_end'));

        return {
            success: true,
            message: 'Item removed successfully'
        };

    } catch (error) {
        console.error('Remove cart item error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runRemoveCartItem;
